import template from './familias-productos.html';
import hijoTemplate from '../form/hijo.html';
import { FormActions } from 'core/services/form';
import familiasProductosI18N from 'i18n/familias-productos/es.json';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';

export let FamiliasProductosComponent = {
  templateUrl: template,
  selector: 'familiasProductos',
  bindings: {
    translations: '='
  },
  controller: FamiliasProductosCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(familiasProductosI18N).concat(commonsI18N);

FamiliasProductosCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'CustomModal', '$scope'
];

function FamiliasProductosCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, CustomModal, $scope) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['nombre', 'codigo'];
  var staticFilter = Filter.path('activo').eq(true).and(Filter.path('padre').isNull());
  BasicFactory.setup('familias-productos');

  this.options = {
    staticFilter,
    resource: 'familias-productos',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de familias de productos'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'nombre', title: this.translations['Nombre'] },
      { data: 'codigo', title: this.translations['Código'] }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_familias_productos'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_familias_productos'),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn btn-primary btn-dt" uib-tooltip="' + this.translations['Ver grafo'] + '" ng-show="canEdit()" ng-click="agregarHijos(<%=dataId%>)"> <span class="glyph-icon icon-cubes" style="top: -8px;"></span></button>',
        functionName: 'agregarHijos',
        functionDef: (itemId) => {
          $state.go('home.familias-productos.uid.hijos', { uid: itemId });
        }
      }
    ]
  };
  this.mapStateToThis = mapStateToThis.bind(this);
  let unsubscribe;

  this.localModel = {};
  const parametroFilter = Filter.path('codigo').eq('familias_productos_niveles');

  this.$onDestroy = () => {
    unsubscribe();
    $ngRedux.dispatch(rest.actions.familiasProducto.reset());
    $ngRedux.dispatch(rest.actions.parametros.reset());
    this.form();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.form();
    $ngRedux.dispatch(rest.actions.familiasProductoPadres({}, {
      body: JSON.stringify(staticFilter)
    }));
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
  };

  this.gotoForm = gotoForm.bind(this);

  function mapStateToThis(state) {

    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.parametros.data && state.parametros.data.length === 1) {
      let parametro = state.parametros.data[0];
      let valor = parseInt(parametro.valor.value);
      if (parametro && valor) {
        this.localModel.niveles = valor;
      }
    }

    if (state.familiasProductoPadres.data && state.familiasProductoPadres.data.length > 0) {
      this.data = state.familiasProductoPadres.data;
    }

    return { form: state.form };
  }

  function gotoForm() {
    this.$state.go('home.familias-productos.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.familias-productos.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('familias-productos', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.familias-productos.uid.view', { uid: itemId });
  }

  this.borrarItem = borrarItem.bind(this);
  this.getDataFlat = getDataFlat.bind(this);
  this.editItem = editItem.bind(this);
  this.newSubItem = newSubItem.bind(this);
  this.firstSubItem = firstSubItem.bind(this);
  this.toggle = toggle.bind(this);
  this.collapseAll = collapseAll.bind(this);
  this.expandAll = expandAll.bind(this);
  this.changeBuscar = changeBuscar.bind(this);

  function toggle(scope) {
    scope.toggle();
  }

  function changeBuscar() {
    // Se filtran las familias activas, que su nombre o codigo coincidan con la busqueda
    let filter = Filter.path('activo').eq(true);
    if (this.localModel.buscar) {
      filter = filter.and(
        Filter.path('nombre').like(this.localModel.buscar).or(Filter.path('codigo').like(this.localModel.buscar))
      );
    }

    $ngRedux.dispatch(rest.actions.familiasProductoPadres({}, {
      body: JSON.stringify(filter)
    }));
  }

  function collapseAll() {
    $scope.$broadcast('angular-ui-tree:collapse-all');
  }

  function expandAll() {
    $scope.$broadcast('angular-ui-tree:expand-all');
  }


  //funciones del form
  function borrarItem(scope) {
    let nodeData = scope.$modelValue;
    const dataFlat = this.getDataFlat();

    if (nodeData.padre) {
      const padre = dataFlat.find(familia => familia.id === nodeData.padre.id);
      const idUltimoHijo = Math.max.apply(null, padre.hijos.map(h => h.id));
      if (nodeData.id !== idUltimoHijo) {
        ngNotify.set('Solo se puede eliminar el último hijo', 'warn');
        return false;
      }
    }

    CustomModal.open({
      title: 'Eliminar Hijo',
      templateUrl: hijoTemplate,
      message: '¿Seguro que desea eliminar el ítem?',
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.delete({ id: nodeData.id }, {
          body: {}
        }, (err, data) => {
          if (!err) {
            scope.remove();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  /**
   * @returns {*} Version aplanada de las familias, es decir todas las familias, padres, hijas, y nietas, en un solo array
   */
  function getDataFlat() {
    const data = this.data || [];
    return data.reduce((dataFlat, familia) => {
      dataFlat.push(familia);
      if (familia.hijos) {
        const hijos = familia.hijos;
        hijos.forEach(hijo => {
          dataFlat.push(hijo);
          if (hijos.hijos) {
            const nietos = familia.hijos;
            nietos.forEach(nieto => {
              dataFlat.push(nieto);
            });
          }
        });
      }
      return dataFlat;
    }, []);
  }

  function newSubItem(scope) {
    var nodeData = scope.$modelValue;
    if (this.localModel.niveles && this.localModel.niveles < nodeData.nivel + 1) {
      ngNotify.set('Nivel maximo alcanzado', 'warn');
      return;
    }

    nodeData.hijos = nodeData.hijos || [];
    this.localModel.payload = {
      padre: nodeData,
      hijos: [],
      ultimoNivel: false
    };
    let self = this;
    CustomModal.open({
      title: 'Nuevo Hijo',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.post({}, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            data[0].nivel = nodeData.nivel + 1;
            nodeData.hijos.push(data[0]);
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  // this.moveLastToTheBeginning = moveLastToTheBeginning.bind(this);

  // function moveLastToTheBeginning() {
  //   var a = this.data.pop();
  //   this.data.splice(0, 0, a);
  // }

  function firstSubItem() {
    this.localModel.payload = {
      hijos: [],
      ultimoNivel: false
    };
    let self = this;
    CustomModal.open({
      title: 'Nuevo Padre',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.post({}, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            data[0].nivel = 1;
            self.data.push(data[0]);
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }


  function editItem(scope) {
    var nodeData = scope.$modelValue;
    this.localModel.payload = nodeData;
    let self = this;
    CustomModal.open({
      title: 'Editar Ítem',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.put({ id: nodeData.id }, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            nodeData = data[0];
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/familias-productos/list/familias-productos.component.js